import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceEscalationsRoute: InvariantJiraRoute = {
	name: 'servicedesk-customer-service-escalations',
	path: '/jira/servicedesk/projects/:projectKey/escalations',
	exact: true,
};
